<script lang="ts" setup>
import { required } from '@vee-validate/rules'
import { useField } from 'vee-validate'
import { useAppStore } from '~/store/app/app'
import { useUserStore } from '~/store/user/user'

import { BadRequestError, Success } from '@/api/results'

const { showSnackbar } = useAppStore()
const { changeInfo } = useUserStore()

const props = defineProps({
  signInRedirectPath: {
    type: String,
    required: false,
    default: null,
  },
})

const emit = defineEmits(['setName'])

const form = ref({
  name: {
    vid: 'full_name',
    id: 'name',
    label: 'Ваше имя',
    value: '',
  },
})

const setNameInProgress = ref(false)

const { setErrors, errorMessage } = useField('name', required)

const setNameHandler = async () => {
  if (!form.value.name.value) {
    setErrors('Введите имя')
    return
  }

  if (form.value.name.value) {
    setNameInProgress.value = true
  }

  const result = await changeInfo({
    full_name: form.value.name.value,
  })

  if (result instanceof BadRequestError) {
    let errorMessage = result.message

    if (typeof result.data === 'object') {
      const dataKey = Object.keys(result.data)[0]
      errorMessage = result.data[dataKey] || result.message
    }

    setErrors(errorMessage)
  } else if (!(result instanceof Success)) {
    showSnackbar({
      message: 'Что-то пошло не так, попробуйте позже',
    })
  }

  setNameInProgress.value = false

  if (props.signInRedirectPath)
    window.location.replace(props.signInRedirectPath)

  emit('setName')
}
</script>

<template>
  <v-form class="form" @submit="setNameHandler">
    <h1 class="form__title">Давайте знакомиться! Укажите ваше имя</h1>

    <label class="form__label" :for="form.name.id">{{ form.name.label }}</label>
    <app-input
      :id="form.name.id"
      v-model="form.name.value"
      class="form__input name"
      solo
      flat
      autofocus
      autocomplete="off"
      :error-messages="errorMessage"
      type="text"
    />

    <app-button
      :loading="setNameInProgress"
      class="form__button set-name"
      block
      @click="setNameHandler"
    >
      Готово
    </app-button>
  </v-form>
</template>

<style lang="scss" scoped>
.form {
  max-width: 320px;
  margin: auto;

  &__title {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 800;
    text-align: center;
  }

  &__label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
  }

  &__input {
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: 600;
    :deep {
      input {
        min-height: 40px;
        padding: 0 0 0 10px;
      }

      .v-field {
        height: 40px;
        background: $button-background !important;
        border-radius: 6px !important;
        box-shadow: none !important;
      }
    }
  }

  &__button {
    height: 50px;
    font-size: 16px;
    font-weight: 800;
    line-height: 19px;
    text-transform: none;
    letter-spacing: 0;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(255, 80, 0, 0.16);

    &:not(:last-child) {
      margin-bottom: 28px;
    }
  }
}
</style>
